export default {
    title: '花小二',
    slogan: '花小二｜AI智能园艺全链路服务商',
    name: '上海花小二科技有限公司',
    /** 联系人 */
    mobileContact: '危经理',
    /** 手机 */
    mobile: '18279700225',
    /** 座机 */
    tel: '021-18279700225',
    phone: '18279700225',
    email: 'jinhui.wei@smart-pal.com',
    businessEmail: 'jinhui.wei@smart-pal.com',
    wechat: '18279700225',
    fax: '021-18279700225',
    address: '上海松江区星月·大业领地116号楼',
    keepOnRecordIcp: '沪ICP备 17005880号-1',
    amapKey: '7e08ae38ab98eb3696eeb1a2dccb1e7a',
    MapInfo: {
      longitude: 121.16,
      latitude: 31.05,
      title: '上海花小二科技有限公司',
      address: '上海松江区星月·大业领地116号楼',
    },
    baseUrl: {
        dev: 'http://localhost:8089',
        pro: 'https://plus.tessai.cn/api',
        devServer: 'http://localhost:8089',
        proServer: 'https://plus.tessai.cn/api',
        cdnUrl: 'https://plus.tessai.cn/'
    },
    customerServiceQQ: '672630243'
}



// WEBPACK FOOTER //
// ./src/config/index.js